module.exports = __webpack_public_path__ + "img/Other-Side.f8222f14.jpg";